// extracted by mini-css-extract-plugin
export var closeButton = "_if-1";
export var closeX = "_if-3";
export var container = "_if-0";
export var image = "_if-2";